import React, { useEffect, useState } from 'react';
import { Card, Button, Badge, Form, Spinner, Dropdown } from 'react-bootstrap';
import {
  getRecetteSession,
  getRecetteTheoriqueSession,
  getRecetteFinanceSession,
  receptionnerRecette,
} from 'data/Finance/caisse';
import { IoAdd } from 'react-icons/io5';

const types = ['Espèce', 'Chèque', 'TPE', 'Sodexo', 'Engagement', 'Traite', 'SODEXO', 'Bon pour'];

const DetailsRecette = ({ selectedRecettes, setSelectedRecettes, montants, setMontants }) => {
  const [montantsTheoriques, setMontantsTheoriques] = useState([]);
  const [montantsFinance, setMontantsFinance] = useState([]);
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [etatRecette, setEtatRecette] = useState('Enveloppe validé');
  const handleDeselect = (id, magasin) => {
    setValues({});
    setMontants([]);
    setMontantsTheoriques([]);
    setSelectedRecettes(selectedRecettes.filter(row => row.ID !== id && row.magasin === magasin));
  };
  const recupererMontants = async () => {
    setLoading(true);
    const conditions = {
      id: selectedRecettes.map(row => row.ID),
      poste: selectedRecettes[0].Poste,
      magasin: selectedRecettes[0].magasin,
    };
    const response = await getRecetteSession(conditions);
    // const response2 = await getRecetteTheoriqueSession(conditions);
    console.log(selectedRecettes);
    // const response3 = await getRecetteFinanceSession({ idFinance: selectedRecettes[0].idFinance });
    setMontants(response);

    console.log(response);
    // console.log(response2);

    setLoading(false);
  };

  useEffect(() => {
    if (selectedRecettes.length > 0) {
      recupererMontants();
    } else {
      setMontants([]);
    }
  }, [selectedRecettes[0]]);

  const receptionnerRecetteFun = async () => {
    const conditions = {
      id: selectedRecettes[0].ID,
      etat: etatRecette,
      poste: selectedRecettes[0].Poste,
      magasin: selectedRecettes[0].magasin,
      montants: montants,
    };
    const promise = montants.map(montant => {
      return new Promise(resolve => {
        const value = values[montant.type] || montant.montant;
        resolve({ type: montant.type, montant: value });
      });
    });
    const valuesFinance = await Promise.all(promise);
    console.log(valuesFinance);
    const response = await receptionnerRecette(conditions, valuesFinance);
    console.log(response);
    setValues({});
    setMontants([]);
    setMontantsTheoriques([]);
    setSelectedRecettes([]);
  };
  return (
    <Card style={{ maxHeight: '450px' }}>
      <Card.Header
        className="d-flex align-items-center justify-content-between gap-2"
        style={{ borderBottom: '1px solid #e0e0e0' }}
      >
        <h5>Details Recette</h5>
        <div>
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              {selectedRecettes.map(row => (
                <Badge
                  key={row.ID}
                  pill
                  bg={
                    row.etatFinance === 'En attente de traitement' || !row.etatFinance
                      ? 'warning'
                      : row.etatFinance === 'Validé'
                      ? 'success'
                      : row.etatFinance === 'A Réctifier'
                      ? 'danger'
                      : row.etatFinance === 'Enveloppe validé'
                      ? 'primary'
                      : 'secondary'
                  }
                  className="me-2"
                  style={{ cursor: 'pointer' }}
                >
                  {`${row.ID}-${row.magasin}`}
                  <Button
                    variant="secondary"
                    type="button"
                    className="ms-2 btn btn-link p-0 m-0 align-baseline"
                    onClick={() => handleDeselect(row.ID, row.magasin)}
                    aria-label="Désélectionner"
                    style={{
                      cursor: 'pointer',
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '1em',
                      lineHeight: 1,
                    }}
                  >
                    &times;
                  </Button>
                </Badge>
              ))}
            </div>
            {/* <Button
              variant="outline-primary"
              className="ms-2"
              onClick={recupererMontants}
              disabled={selectedRecettes.length === 0}
            >
              <div className="d-flex align-items-center">
                {loading && <Spinner size="sm" className="me-2" />}
                Recuperer Montants
              </div>
            </Button> */}
          </div>
        </div>
      </Card.Header>
      <Card.Body>
        <div className="d-flex align-items-center gap-2 mb-2">
          <Dropdown className="d-inline-block" disabled={montants.length > 0}>
            <Dropdown.Toggle variant="outline-primary" className="px-2 py-0">
              <IoAdd />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {types
                .filter(type => !montants.some(m => m.type === type))
                .map(type => (
                  <Dropdown.Item
                    key={type}
                    onClick={() =>
                      setMontants([...montants, { type, montant: 0, montantValide: 0 }])
                    }
                  >
                    {type}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
          <h5>Details Recette</h5>
        </div>
        <div style={{ overflowY: 'auto', maxHeight: '200px' }}>
          {montants.map(montant => (
            <div key={montant.id} style={{ marginBottom: '10px', overflowY: 'auto' }}>
              <h6>{montant.type}</h6>
              <div className="d-flex gap-2 align-items-center">
                <div
                  style={{ borderRight: '1px solid #e0e0e0', padding: '5px', paddingRight: '15px' }}
                >
                  <h6>Quantité</h6>
                  <h6>{montant.nombre || 0}</h6>
                </div>
                <div
                  style={{ borderRight: '1px solid #e0e0e0', padding: '5px', paddingRight: '15px' }}
                >
                  <h6>Montant Enveloppe</h6>
                  <h6>{montant.montant.toFixed(3)}</h6>
                </div>
                <Form.Group
                  style={{ borderRight: '1px solid #e0e0e0', padding: '5px', paddingRight: '15px' }}
                >
                  <h6>Qté validée</h6>
                  <Form.Control
                    style={{ width: '100px' }}
                    type="number"
                    defaultValue={montant.nombre || 0}
                    value={montant.nombreValide || montant.nombre}
                    onChange={e => {
                      setMontants(
                        montants.map(m =>
                          m.type === montant.type
                            ? { ...m, nombreValide: parseInt(e.target.value, 10) }
                            : m
                        )
                      );
                      console.log(montants);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <h6>Montant Validé</h6>
                  <Form.Control
                    style={{ width: '200px' }}
                    type="number"
                    defaultValue={montant.montant.toFixed(3)}
                    value={montant.montantValide || montant.montant.toFixed(3)}
                    onChange={e =>
                      setMontants(
                        montants.map(m =>
                          m.type === montant.type
                            ? { ...m, montantValide: parseFloat(e.target.value) }
                            : m
                        )
                      )
                    }
                  />
                </Form.Group>
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
      <Card.Footer>
        <div className="d-flex align-items-end gap-2">
          <Form.Group className="ms-3" style={{ width: '250px' }}>
            <Form.Label>Etat</Form.Label>
            <Form.Select
              size="sm"
              value={etatRecette}
              onChange={e => setEtatRecette(e.target.value)}
            >
              <option>Enveloppe validé</option>
              <option>En attente de traitement</option>
              <option>En cours de traitement</option>
              <option>Validé</option>
              <option>A Réctifier</option>
            </Form.Select>
          </Form.Group>
          <Button
            variant="primary"
            onClick={receptionnerRecetteFun}
            disabled={
              selectedRecettes.length === 0 ||
              selectedRecettes.some(row => row.etatFinance === 'Validé') ||
              selectedRecettes.some(
                row =>
                  row.etatFinance !== selectedRecettes[0].etatFinance ||
                  row.magasin !== selectedRecettes[0].magasin
              )
            }
          >
            Réceptionner Recette
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default DetailsRecette;
